"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var DropdownButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/DropdownButton"));
var general_1 = require("utils/general");
var StyledDropdownButton = (0, material_1.styled)(DropdownButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('mr', 'useNeutralColor') })(function (_a) {
    var _b;
    var theme = _a.theme, mr = _a.mr, useNeutralColor = _a.useNeutralColor;
    return (__assign({ marginRight: theme.spacing(mr !== null && mr !== void 0 ? mr : -3.375), marginBottom: theme.spacing(0.5) }, useNeutralColor && { '&.MuiButton-textNeutral, & .MuiButton-endIcon svg': { color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main } }));
});
exports.default = StyledDropdownButton;
